import { ReactNode, createContext } from "react";

import { FullScreen, useFullScreenHandle } from "@/hooks/browser/useFullScreen";

type FullScreenHandle = ReturnType<typeof useFullScreenHandle>;

const FullScreenContext = createContext<FullScreenHandle | null>(null);

export const FullScreenShim = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const handle = useFullScreenHandle();

  return (
    <FullScreen handle={handle}>
      <FullScreenContext.Provider value={handle}>
        {children}
      </FullScreenContext.Provider>
    </FullScreen>
  );
};
